import {
  BreadcrumbsModule,
  CardModule,
  EnhancedFilterModule,
  DividerModule,
  DropdownModule,
  FlexboxModule,
  FlyoutMenuModule,
  GridModule,
  IconModule,
  ImageModule,
  PaddingModule,
  PaginationModule,
  SearchModule,
  SideBarModule,
  SpacingModule,
  TitleModule,
  ToggleModule,
  PanelModule,
  BannerModule as EdsBannerModule,
  LinkItemModule,
  VideoModule,
  PromoCardModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { ArticleCollectionComponent } from './article-collection/article-collection.component';
import { ArticleHubComponent } from './article-hub/article-hub.component';
import { InsightsCardsComponent } from './insights-cards/insights-cards.component';
import { InsightsLibraryComponent } from './insights-library/insights-library.component';
import { InsightsFiltersComponent } from './insights-library/insights-filters/insights-filters.component';
import { InsightsTagsComponent } from './insights-tags/insights-tags.component';
import { InsightsSidebarComponent } from './insights-library/insights-sidebar/insights-sidebar.component';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { InsightsReportComponent } from './insights-library/insights-report/insights-report.component';
import { TextBlockModule } from '@marketing/content-blocks/text-block/text-block.module';
import { AvatarBlockModule } from '@marketing/content-blocks/avatar-block/avatar-block.module';
import { TitleBlockModule } from '@marketing/content-blocks/title-block/title-block.module';
import { ImageBlockModule } from '@marketing/content-blocks/image-block/image-block.module';
import { BlockQuoteBlockModule } from '@marketing/content-blocks/blockquote-block/blockquote-block.module';
@NgModule({
  declarations: [
    ArticleCollectionComponent,
    ArticleHubComponent,
    InsightsCardsComponent,
    InsightsFiltersComponent,
    InsightsLibraryComponent,
    InsightsTagsComponent,
    InsightsSidebarComponent,
    InsightsReportComponent,
  ],
  imports: [
    AvatarBlockModule,
    BlockQuoteBlockModule,
    BreadcrumbsModule,
    BrSdkModule,
    CardModule,
    CommonModule,
    EnhancedFilterModule,
    DividerModule,
    DropdownModule,
    FlexboxModule,
    FlyoutMenuModule,
    GridModule,
    IconModule,
    ImageModule,
    ImageBlockModule,
    PaddingModule,
    PaginationModule,
    PromoCardModule,
    SearchModule,
    SideBarModule,
    SpacingModule,
    TitleModule,
    TextBlockModule,
    TitleBlockModule,
    ToggleModule,
    PanelModule,
    EdsBannerModule,
    LinkItemModule,
    PipesModule,
    VideoModule,
  ],
  exports: [
    ArticleHubComponent,
    InsightsCardsComponent,
    InsightsFiltersComponent,
    InsightsLibraryComponent,
    InsightsSidebarComponent,
    InsightsTagsComponent,
  ],
  entryComponents: [
    ArticleHubComponent,
    InsightsCardsComponent,
    InsightsLibraryComponent,
  ],
})

/**
 * Insights Module
 */
export class InsightsModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Article Collection': ArticleCollectionComponent,
      'Article Hub': ArticleHubComponent,
      'Insights Cards': InsightsCardsComponent,
      'Insights Library': InsightsLibraryComponent,
    };
  }
}
